import { Data } from './types';

export const getCardList = (professionalId: number | string): Data[] => [
  {
    id: 1,
    title: 'Comercial',
    url: `/professional/manager-report/commercial`,
  },
  {
    id: 2,
    title: 'Gestão Técnica',
    url: `/professional/manager-report/technical-management`,
  },
  {
    id: 3,
    title: 'Gestão de Faturamento',
    url: `${process.env.REACT_APP_API_URL}/reports/${professionalId}/billing-management`,
  },
];
